import * as React from 'react';
//import { aTextInput } from '../../../../../shared-components/source/aTextInput.jsx';
import ATextInput from '../shared/aTextInput.jsx';
import * as agui from 'arm-gui/dist/controls';

class TestATextInput extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.invia = this.invia.bind(this);

        this.componentName = "[TestATextInput.jsx] ";
        this.state = {
            nome: '',
            cognome: ''
        }
    }

    handleChange(event) {
        console.log('id: ' + event.target.id + " value: " + event.target.value);
        /*
                if (target.name === "nome") {
                    this.setState({ nome: target.value });
                }
                else if (target.name === "cognome") {
                    this.setState({ cognome: target.value });
                }
                else {
                    console.warn("target.name NON riconosciuto: " + target.name)
                }
        */
    }
    invia() {
        console.log(this.componentName + "invia");

        let log = document.getElementById('log');
        log.insertAdjacentHTML('beforeend', '<h1> nome </h1> ' + this.state.nome);
    }

    render() {
        console.log(this.componentName + "render");
        return (
            <div>
                <p>Esempio di utilizzo del componente ATextInput</p>


                <p>ATextInput da shared</p>
                <div className="form-group">

                    <ATextInput id="nome" value={this.state.nome} onChange={this.handleChange} />


                </div>



                <hr />
                <p>ATextInput da AGUI</p>
                <div className="form-group">
                    <agui.CoolTextInput id="cognome" label="Cognome" value={this.state.nome} onChange={(value)=>this.handleChange({
                        target: {
                            value: value,
                            id: "cognome",
                        }
                    })} />
                </div>



                <button className="btn btn-info" onClick={this.invia}> Invia </button>
                <div id="log"></div>

            </div>
        );
    }
}

export default TestATextInput;